module.exports = __webpack_public_path__ + "img/ImagenLandingBolsaEmpleo.ce7cb1fd.svg";